import * as R from 'ramda'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import * as ReactRedux from 'react-redux'
import * as Urql from 'urql'

import * as I18n from '@rushplay/i18n'
import * as Notifications from '@rushplay/notifications'

import * as Icons from './icons'
import { NavigationLink, PageNavigation } from './page-navigation'

const getCasinoCategories = `
  query CasinoCategories {
    catalog(key: "main") {
      ... on GetCatalogSuccess {
        categories {
          id
          key
        }
      }
      ... on GetCatalogFailure {
        error
        errorCode
      }
    }
  }
`

export function CasinoNavigation() {
  const [response] = Urql.useQuery({ query: getCasinoCategories })
  const location = ReactRouter.useLocation()
  const dispatch = ReactRedux.useDispatch()
  const i18n = I18n.useI18n()

  const search = (
    <NavigationLink key="search" to="/casino/search">
      <Icons.Search /> {i18n.translate('page-navigation.search')}
    </NavigationLink>
  )

  if (response.error) {
    dispatch(
      Notifications.add({
        level: 'error',
        message: 'errors.casino-navigation.fetch-failed',
      })
    )
  }

  if (response.fetching || response.error) {
    return <PageNavigation header="casino" withSearch />
  }

  const navigationItems = R.map(
    item => ({
      label: item.key,
      to: `/casino/${item.id}/${item.key}`,
    }),
    R.pathOr([], ['catalog', 'categories'], response.data)
  )

  const items = R.map(
    item => (
      <NavigationLink key={item.to} to={item.to}>
        {i18n.translate(item.label)}
      </NavigationLink>
    ),
    navigationItems
  )

  return (
    <ReactRouter.Switch>
      <ReactRouter.Redirect
        exact
        from="/casino"
        to={{
          pathname: R.path(['to'], R.head(navigationItems)),
          search: location.search,
        }}
      />
      <ReactRouter.Route>
        <PageNavigation items={[search, ...items]} header="casino" />
      </ReactRouter.Route>
    </ReactRouter.Switch>
  )
}

// For @loadable/components
export default CasinoNavigation
